// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ansi-green-fg {
    color: #859900;
}

.ansi-yellow-fg {
    color: #b58900;
}

.ansi-red-fg {
    color: #dc322f;
}`, "",{"version":3,"sources":["webpack://./src/console/logs.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".ansi-green-fg {\n    color: #859900;\n}\n\n.ansi-yellow-fg {\n    color: #b58900;\n}\n\n.ansi-red-fg {\n    color: #dc322f;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
